//@ts-nocheck

const quiz = () => {
  const wrapper = document.querySelector(".js-quiz-questions");
  if (!wrapper) {
    return;
  }
  const page = wrapper?.getAttribute("data-page");
  const branchTitle = document.querySelector(".js-branch-title");

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("js-quiz-question")) {
      let index = e.target.getAttribute("data-index");
      fetchData(page, index);
    } else if (e.target.classList.contains("js-quiz-toggle")) {
      e.preventDefault();
      let toggles = document.querySelectorAll(".js-quiz-toggle");
      let continueBtn = document.querySelector(".js-quiz-continue");
      toggles.forEach((toggle) => {
        toggle.classList.remove("active");
      });
      continueBtn?.classList.remove("disabled");
      let link = e.target.getAttribute("href");
      continueBtn?.setAttribute("href", link);
      e.target.classList.add("active");
    } else if (e.target.classList.contains("js-quiz-reset")) {
      fetchDefault();
    }
  });
  async function fetchDefault() {
    let formData = new FormData();
    formData.append("action", "quiz_ajax_default");
    formData.append("page", page);
    const response = await fetch(window.globals.ajax_url, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    branchTitle.innerText = data.title;
    wrapper.innerHTML = data.files;
  }
  async function fetchData(page, index) {
    let formData = new FormData();
    formData.append("action", "quiz_ajax");
    formData.append("page", page);
    formData.append("index", index);
    const response = await fetch(window.globals.ajax_url, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    branchTitle.innerText = data.title;
    wrapper.innerHTML = data.files;
  }
};

export default quiz;
